import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=21e99d47&scoped=true&"
import script from "./ShareButton.vue?vue&type=script&lang=ts&"
export * from "./ShareButton.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=21e99d47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e99d47",
  null
  
)

export default component.exports